import { parseBooleanString, parseInteger } from "../../util/utility";
import { CXoneEvent } from './agent/cxone-event';

/**
 * Model class for skill
 */
export class SkillEvent extends CXoneEvent {
  /**
   * @remarks  Media type number
   */
  public mediaType!: number;

  /**
   * @remarks  Media type name of the channel like Chat, email, call etc..
   */
  public mediaName!: string;

  /**
   * @remarks  Indicates if skill is in ACTIVE state
   */
  public isActive!: boolean;

  /**
   * @remarks  Indicates if the skill is an outbound Skill
   */
  public isOutbound!: boolean;

  /**
   * @remarks  ISO 8601 timestamp of last database poll. Value should be passed in "updatedSince" parameter on next call
   */
  public lastPollTime!: Date;

  /**
   * @remarks  Time of last record update
   */
  public lastUpdateTime!: Date;

  /**
   * @remarks  ID of Skill
   */
  public skillId!: string;

  /**
   * @remarks  Name of Skill
   */
  public skillName!: string;

  /**
   * This method to parse skill data
   * @param data - key value pair data
   * @example -
   * ```
   * parse(data);
   * ```
   */
  parse(data: { [key: string]: string }): void {
    this.mediaType = parseInteger(data.MediaType);
    this.mediaName = data.MediaName;
    this.isOutbound = parseBooleanString(data.IsOutbound);
    this.isActive = parseBooleanString(data.isActive);
    this.skillId = data.SkillId;
    this.skillName = data.SkillName;
    this.lastPollTime = new Date(data.lastPollTime);
    this.lastUpdateTime = new Date(data.lastUpdateTime);
  }
};
